import { useEffect, useState } from 'react';
import { useUsersStore } from '../stores/usersStore';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M19 19L14.667 14.667M17 9.5C17 13.6421 13.6421 17 9.5 17C5.35786 17 2 13.6421 2 9.5C2 5.35786 5.35786 2 9.5 2C13.6421 2 17 5.35786 17 9.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M11.333 2C11.5081 1.82495 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82495 13.9997 2C14.1747 2.17505 14.3136 2.38295 14.4084 2.61169C14.5032 2.84044 14.5519 3.0856 14.5519 3.33333C14.5519 3.58107 14.5032 3.82623 14.4084 4.05497C14.3136 4.28372 14.1747 4.49162 13.9997 4.66667L4.33301 14.3333L1.33301 15.3333L2.33301 12.3333L11.333 2Z" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 4H14M5.333 4V2.667C5.333 2.298 5.632 2 6 2H10C10.368 2 10.667 2.298 10.667 2.667V4M12.667 4V13.333C12.667 13.702 12.368 14 12 14H4C3.632 14 3.333 13.702 3.333 13.333V4" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BanIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.333"/>
    <path d="M3 13L13 3" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChatIcon = () => (
  <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
    <path d="M3 4.5C3 3.397 3.897 2.5 5 2.5H15C16.103 2.5 17 3.397 17 4.5V11.5C17 12.603 16.103 13.5 15 13.5H7.5L3 17.5V13.5H5C3.897 13.5 3 12.603 3 11.5V4.5Z" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const AdHistoryIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="2" width="14" height="12" rx="2" stroke="currentColor" strokeWidth="1.333"/>
    <path d="M4 6H12M4 9H8" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round"/>
  </svg>
);

// Modal для редактирования баланса
const BalanceModal = ({ isOpen, onClose, user, onSave }) => {
  const [balance, setBalance] = useState('');

  useEffect(() => {
    if (user) {
      setBalance(user.balance?.toString() || '0');
    }
  }, [user]);

  if (!isOpen || !user) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-bg-secondary border border-border-color rounded-xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-text-primary">Изменить баланс</h3>
          <button onClick={onClose} className="text-text-secondary hover:text-text-primary">
            <CloseIcon />
          </button>
        </div>

        <div className="mb-4">
          <div className="text-sm text-text-secondary mb-1">Пользователь</div>
          <div className="text-text-primary font-medium">ID: {user.id} | VK: {user.vk_user_id}</div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-text-secondary mb-2">
            Новый баланс (звёзды)
          </label>
          <input
            type="number"
            value={balance}
            onChange={(e) => setBalance(e.target.value)}
            className="w-full px-4 py-3 bg-bg-tertiary border border-border-color rounded-lg text-text-primary focus:outline-none focus:border-accent-primary"
            min="0"
          />
        </div>

        <div className="flex gap-3">
          <button onClick={onClose} className="flex-1 py-2.5 px-4 bg-bg-tertiary hover:bg-bg-primary text-text-primary rounded-lg font-medium transition-colors">
            Отмена
          </button>
          <button onClick={() => onSave(user.id, parseInt(balance))} className="flex-1 py-2.5 px-4 bg-accent-primary hover:bg-accent-hover text-white rounded-lg font-medium transition-colors">
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
};

// Confirm Modal
const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Подтвердить', confirmVariant = 'error' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onCancel}>
      <div className="bg-bg-secondary border border-border-color rounded-xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-lg font-semibold text-text-primary mb-2">{title}</h3>
        <p className="text-text-secondary mb-6">{message}</p>
        <div className="flex gap-3">
          <button onClick={onCancel} className="flex-1 py-2.5 px-4 bg-bg-tertiary hover:bg-bg-primary text-text-primary rounded-lg font-medium transition-colors">
            Отмена
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 py-2.5 px-4 rounded-lg font-medium transition-colors ${
              confirmVariant === 'error' ? 'bg-error hover:bg-red-600 text-white' : 'bg-accent-primary hover:bg-accent-hover text-white'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export const Users = () => {
  const { users, total, isLoading, filters, fetchUsers, blockUser, unblockUser, updateUserBalance, deleteUser } = useUsersStore();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const [page, setPage] = useState(0);
  const [balanceModal, setBalanceModal] = useState({ isOpen: false, user: null });
  const [adHistoryModal, setAdHistoryModal] = useState({ isOpen: false, user: null, ads: [], loading: false, page: 1, totalPages: 1, total: 0 });
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, action: null, user: null });

  const limit = 20;

  // Инициализация: проверяем URL параметр search
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const searchParam = params.get('search');
    if (searchParam) {
      setSearch(searchParam);
    }
  }, []);

  useEffect(() => {
    const debounce = setTimeout(() => {
      fetchUsers({ limit, offset: page * limit, search, status });
    }, 300);

    return () => clearTimeout(debounce);
  }, [search, status, page]);

  const handleBlock = (user) => {
    setConfirmModal({
      isOpen: true,
      action: 'block',
      user,
      title: 'Заблокировать пользователя?',
      message: `Пользователь ${user.vk_user_id} будет заблокирован и не сможет пользоваться приложением.`,
      confirmText: 'Заблокировать',
    });
  };

  const handleUnblock = (user) => {
    setConfirmModal({
      isOpen: true,
      action: 'unblock',
      user,
      title: 'Разблокировать пользователя?',
      message: `Пользователь ${user.vk_user_id} сможет снова пользоваться приложением.`,
      confirmText: 'Разблокировать',
      confirmVariant: 'success',
    });
  };

  const handleDelete = (user) => {
    setConfirmModal({
      isOpen: true,
      action: 'delete',
      user,
      title: 'Удалить пользователя?',
      message: `Пользователь ${user.vk_user_id} и все его данные (чаты, сообщения) будут безвозвратно удалены.`,
      confirmText: 'Удалить',
    });
  };

  const handleViewChats = (user) => {
    navigate(`/chats?user_id=${user.vk_user_id}`);
  };

  const handleViewAdHistory = async (user) => {
    setAdHistoryModal({ isOpen: true, user, ads: [], loading: true, page: 1, totalPages: 1, total: 0 });
    try {
      const result = await api.getUserAdHistory(user.id, 1, 20);
      setAdHistoryModal(prev => ({ 
        ...prev, 
        ads: result.ads || [], 
        loading: false, 
        page: result.page, 
        totalPages: result.totalPages, 
        total: result.total 
      }));
    } catch (error) {
      console.error('Ошибка загрузки истории рекламы:', error);
      setAdHistoryModal(prev => ({ ...prev, loading: false }));
    }
  };

  const handleAdHistoryPageChange = async (newPage) => {
    if (!adHistoryModal.user) return;
    setAdHistoryModal(prev => ({ ...prev, loading: true }));
    try {
      const result = await api.getUserAdHistory(adHistoryModal.user.id, newPage, 20);
      setAdHistoryModal(prev => ({ 
        ...prev, 
        ads: result.ads || [], 
        loading: false, 
        page: result.page, 
        totalPages: result.totalPages 
      }));
    } catch (error) {
      console.error('Ошибка загрузки истории рекламы:', error);
      setAdHistoryModal(prev => ({ ...prev, loading: false }));
    }
  };

  const handleConfirm = async () => {
    const { action, user } = confirmModal;
    
    if (action === 'block') {
      await blockUser(user.id);
    } else if (action === 'unblock') {
      await unblockUser(user.id);
    } else if (action === 'delete') {
      await deleteUser(user.id);
    }
    
    setConfirmModal({ isOpen: false, action: null, user: null });
  };

  const handleSaveBalance = async (id, balance) => {
    await updateUserBalance(id, balance);
    setBalanceModal({ isOpen: false, user: null });
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-text-primary">Пользователи</h1>
        <div className="text-sm text-text-secondary">
          Всего: <span className="text-text-primary font-medium">{total}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <input
            type="text"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(0); }}
            placeholder="Поиск по ID или VK ID..."
            className="w-full pl-10 pr-4 py-2.5 bg-bg-secondary border border-border-color rounded-lg text-text-primary placeholder-text-muted focus:outline-none focus:border-accent-primary"
          />
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted">
            <SearchIcon />
          </div>
        </div>

        <select
          value={status}
          onChange={(e) => { setStatus(e.target.value); setPage(0); }}
          className="px-4 py-2.5 bg-bg-secondary border border-border-color rounded-lg text-text-primary focus:outline-none focus:border-accent-primary"
        >
          <option value="all">Все</option>
          <option value="active">Активные</option>
          <option value="disabled">Заблокированные</option>
        </select>
      </div>

      {/* Table */}
      <div className="bg-bg-secondary rounded-xl border border-border-color overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-bg-tertiary border-b border-border-color">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">ID</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">VK User ID</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">Баланс</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">Статус</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">Дата регистрации</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-text-secondary uppercase tracking-wider">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border-color">
              {isLoading ? (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-text-secondary">
                    <div className="animate-spin h-6 w-6 border-2 border-accent-primary border-t-transparent rounded-full mx-auto" />
                  </td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-text-secondary">
                    Пользователи не найдены
                  </td>
                </tr>
              ) : (
                users.map((user) => (
                  <tr key={user.id} className="hover:bg-bg-tertiary/50 transition-colors">
                    <td className="px-4 py-3 text-sm text-text-primary">{user.id}</td>
                    <td className="px-4 py-3 text-sm text-text-secondary font-mono">{user.vk_user_id}</td>
                    <td className="px-4 py-3 text-sm">
                      <span className="text-accent-primary font-medium">{user.balance} ⭐</span>
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        user.is_disabled
                          ? 'bg-error/10 text-error'
                          : 'bg-success/10 text-success'
                      }`}>
                        {user.is_disabled ? 'Заблокирован' : 'Активен'}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-text-secondary">
                      {new Date(user.created_at).toLocaleDateString('ru-RU')}
                    </td>
                    <td className="px-4 py-3 text-right">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          onClick={() => handleViewChats(user)}
                          className="p-1.5 text-text-secondary hover:text-accent-primary transition-colors"
                          title="Просмотреть чаты"
                        >
                          <ChatIcon />
                        </button>
                        <button
                          onClick={() => handleViewAdHistory(user)}
                          className="p-1.5 text-text-secondary hover:text-purple-400 transition-colors"
                          title="История рекламы"
                        >
                          <AdHistoryIcon />
                        </button>
                        <button
                          onClick={() => setBalanceModal({ isOpen: true, user })}
                          className="p-1.5 text-text-secondary hover:text-accent-primary transition-colors"
                          title="Изменить баланс"
                        >
                          <EditIcon />
                        </button>
                        {user.is_disabled ? (
                          <button
                            onClick={() => handleUnblock(user)}
                            className="p-1.5 text-text-secondary hover:text-success transition-colors"
                            title="Разблокировать"
                          >
                            <CheckIcon />
                          </button>
                        ) : (
                          <button
                            onClick={() => handleBlock(user)}
                            className="p-1.5 text-text-secondary hover:text-error transition-colors"
                            title="Заблокировать"
                          >
                            <BanIcon />
                          </button>
                        )}
                        <button
                          onClick={() => handleDelete(user)}
                          className="p-1.5 text-text-secondary hover:text-error transition-colors"
                          title="Удалить"
                        >
                          <TrashIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex items-center justify-between">
          <div className="text-sm text-text-secondary">
            Страница {page + 1} из {totalPages}
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => setPage(p => Math.max(0, p - 1))}
              disabled={page === 0}
              className="px-4 py-2 bg-bg-secondary border border-border-color rounded-lg text-text-primary disabled:opacity-50 disabled:cursor-not-allowed hover:bg-bg-tertiary transition-colors"
            >
              Назад
            </button>
            <button
              onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
              disabled={page >= totalPages - 1}
              className="px-4 py-2 bg-bg-secondary border border-border-color rounded-lg text-text-primary disabled:opacity-50 disabled:cursor-not-allowed hover:bg-bg-tertiary transition-colors"
            >
              Вперёд
            </button>
          </div>
        </div>
      )}

      <BalanceModal
        isOpen={balanceModal.isOpen}
        onClose={() => setBalanceModal({ isOpen: false, user: null })}
        user={balanceModal.user}
        onSave={handleSaveBalance}
      />

      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={handleConfirm}
        onCancel={() => setConfirmModal({ isOpen: false, action: null, user: null })}
        confirmText={confirmModal.confirmText}
        confirmVariant={confirmModal.confirmVariant}
      />

      {/* Модальное окно истории просмотров рекламы */}
      {adHistoryModal.isOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setAdHistoryModal({ isOpen: false, user: null, ads: [], loading: false, page: 1, totalPages: 1, total: 0 })}>
          <div className="bg-bg-secondary border border-border-color rounded-xl max-w-2xl w-full max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
            {/* Заголовок */}
            <div className="flex items-center justify-between p-4 border-b border-border-color">
              <div>
                <h3 className="text-lg font-semibold text-text-primary">История просмотра рекламы</h3>
                <p className="text-sm text-text-secondary">VK ID: {adHistoryModal.user?.vk_user_id}</p>
              </div>
              <button 
                onClick={() => setAdHistoryModal({ isOpen: false, user: null, ads: [], loading: false, page: 1, totalPages: 1, total: 0 })}
                className="p-2 text-text-secondary hover:text-text-primary"
              >
                <CloseIcon />
              </button>
            </div>

            {/* Контент */}
            <div className="flex-1 overflow-y-auto p-4">
              {adHistoryModal.loading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="animate-spin h-8 w-8 border-2 border-accent-primary border-t-transparent rounded-full" />
                </div>
              ) : adHistoryModal.ads.length === 0 ? (
                <div className="text-center py-8 text-text-secondary">
                  Нет данных о просмотре рекламы
                </div>
              ) : (
                <>
                  <div className="text-sm text-text-secondary mb-4">
                    Всего просмотров: {adHistoryModal.total}
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-bg-tertiary border-b border-border-color">
                        <tr>
                          <th className="px-3 py-2 text-left text-xs font-medium text-text-secondary">№</th>
                          <th className="px-3 py-2 text-left text-xs font-medium text-text-secondary">Дата и время</th>
                          <th className="px-3 py-2 text-right text-xs font-medium text-text-secondary">Награда</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-border-color">
                        {adHistoryModal.ads.map((ad, index) => (
                          <tr key={ad.id}>
                            <td className="px-3 py-2 text-sm text-text-secondary">
                              {(adHistoryModal.page - 1) * 20 + index + 1}
                            </td>
                            <td className="px-3 py-2 text-sm text-text-primary">
                              {new Date(ad.viewed_at).toLocaleString('ru-RU')}
                            </td>
                            <td className="px-3 py-2 text-sm text-amber-400 text-right">
                              +{ad.reward}⭐
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>

            {/* Пагинация */}
            {adHistoryModal.totalPages > 1 && (
              <div className="flex items-center justify-between p-4 border-t border-border-color">
                <button
                  onClick={() => handleAdHistoryPageChange(adHistoryModal.page - 1)}
                  disabled={adHistoryModal.page <= 1}
                  className="px-3 py-1.5 text-sm bg-bg-tertiary text-text-secondary hover:text-text-primary rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Назад
                </button>
                <span className="text-sm text-text-secondary">
                  {adHistoryModal.page} / {adHistoryModal.totalPages}
                </span>
                <button
                  onClick={() => handleAdHistoryPageChange(adHistoryModal.page + 1)}
                  disabled={adHistoryModal.page >= adHistoryModal.totalPages}
                  className="px-3 py-1.5 text-sm bg-bg-tertiary text-text-secondary hover:text-text-primary rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Вперёд
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
